import { AppContext } from "01Data/AppData";
import PageTemplate from "04UserPages/00PageTemplate/PageTemplate";
import {
  BreadCrumbItem,
  BreadCrumbList,
} from "04UserPages/99Parts/BreadCrumbList";
import { NoteText } from "97Parts/Styles";
import { useModel } from "99Tools/useModel";
import { CheckKizaiID } from "99Tools/utils";
import { AddCircle, Cancel, CheckCircle } from "@mui/icons-material";
import IconPhotoCamera from "@mui/icons-material/PhotoCamera";
import IconStop from "@mui/icons-material/Stop";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  styled,
} from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { SECTION } from "deviceList";
import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BOLD_TEXT_COLOR } from "../../Settings";
import LTETable, { DetailFormLTE } from "./LTETable";

export const CurrentSection = createContext("");

const FormDlg = styled("form")(({ theme }) => ({
  marginTop: theme.spacing(1),
  width: "100%", // Fix IE 11 issue.
}));

const ErrorText = styled("div")(({ theme }) => ({
  color: "#f00",
  margin: "0 0 10px",
}));

const BoldText = styled("div")(({ theme }) => ({
  margin: "0 0 10px",
  fontSize: "1.125rem",
  lineHeight: "1.75rem",
  color: BOLD_TEXT_COLOR,
  overflowWrap: "anywhere",
}));

const ButtonDlg = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1, 0, 1),
}));

const RegisterForm = () => {
  const d = useContext(AppContext).dataUser.locations;
  const c = useContext(AppContext).dataUser.camera;
  const p = d.pageDevices;
  const navigate = useNavigate();
  const [id, setId] = useState("");
  const [message, setMesasge] = useState("");

  const handleClose = () => {
    p.bShowRegisterDlg = false;
    c.CameraOff();
    setMesasge("");
    p.changed();
  };

  const handleChangeId = (e: any) => {
    setId(e.target.value);
    setMesasge("");
  };

  const handleRegister = () => {
    if (id === "") {
      setMesasge("機材IDを入力してください。");
      return;
    }
    const kind = CheckKizaiID(id);
    if (kind !== "pico3" && kind !== "lte" && kind !== "subgiga") {
      setMesasge("機材IDが不正です。");
      return;
    }
    p.bShowRegisterDlg = false;
    const buildingId = p.building.BuildingId;
    d.ResetPageData();
    navigate(`/devices/register?building=${buildingId}&id=${id}`);
  };

  const handleChangeCamera = (e: any) => {
    c.camera = e.target.value;
    c.CameraSwitch("qrcamera", setId, setMesasge);
    p.changed();
  };

  const handleStartCamera = () => {
    c.CameraOn("qrcamera", setId, setMesasge);
  };

  const handleStopCamera = () => {
    c.CameraOff();
  };

  const list = c.cameras.map((item: MediaDeviceInfo) => (
    <MenuItem value={item.deviceId} key={item.deviceId}>
      <div>{item.label}</div>
    </MenuItem>
  ));

  return (
    <Dialog key="register" open={p.bShowRegisterDlg}>
      <FormDlg noValidate>
        <DialogTitle>デバイスの追加</DialogTitle>
        <DialogContent>
          <BoldText>{`建物: ${p.building.BuildingName}`}</BoldText>
          <NoteText>漏水みはり番の機材IDを入力してください。</NoteText>
          <TextField
            variant="filled"
            margin="normal"
            fullWidth
            required
            id="id"
            label="機材ID"
            name="id"
            onChange={handleChangeId}
            inputProps={{ maxLength: 128 }}
            value={id}
          />
          <ErrorText>{message === "" ? "　" : message}</ErrorText>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="dlg_contact_kind_label">カメラ</InputLabel>
            <Select
              labelId="dlg_contact_kind_label"
              id="dlg_contact_kind"
              value={c.camera}
              label="カメラ"
              onChange={handleChangeCamera}
            >
              {list.length === 0 ? (
                <MenuItem value="">
                  <div>なし</div>
                </MenuItem>
              ) : (
                list
              )}
            </Select>
          </FormControl>
          <video
            className="qrcamera"
            style={{ width: "100%", maxWidth: "1000px", marginTop: "1em" }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <ButtonDlg
              variant="contained"
              color="secondary"
              fullWidth
              onClick={handleStartCamera}
            >
              <IconPhotoCamera />
            </ButtonDlg>
            <ButtonDlg
              variant="contained"
              color="secondary"
              fullWidth
              onClick={handleStopCamera}
            >
              <IconStop />
            </ButtonDlg>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <ButtonDlg
              startIcon={<CheckCircle />}
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleRegister}
            >
              確定
            </ButtonDlg>
            <ButtonDlg
              startIcon={<Cancel />}
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleClose}
            >
              キャンセル
            </ButtonDlg>
          </div>
        </DialogContent>
      </FormDlg>
    </Dialog>
  );
};

// const Pico3Section = () => {
//   const d = useContext(AppContext).dataUser.locations.pageDevices;
//   const isSmartphone = useMediaQuery({
//     query: "(max-width: 600px)",
//   });

//   if (d.pico3.length === 0) {
//     return null;
//   }

//   return (
//     <>
//       <div
//         style={{
//           width: isSmartphone ? "100%" : "15vw",
//           textAlign: "center",
//           borderStyle: "solid",
//           borderWidth: "1px",
//           borderRadius: "6px",
//           margin: "10px 0 10px",
//         }}
//       >
//         Pico3
//       </div>
//       <Pico3Table />
//     </>
//   );
// };

const LTESection = () => {
  const d = useContext(AppContext).dataUser.locations.pageDevices;
  // const isSmartphone = useMediaQuery({
  //   query: "(max-width: 600px)",
  // });

  if (d.LTE.length === 0) {
    return null;
  }

  return (
    <>
      {/* <div
        style={{
          width: isSmartphone ? "100%" : "15vw",
          textAlign: "center",
          borderStyle: "solid",
          borderWidth: "1px",
          borderRadius: "6px",
          margin: "10px 0 10px",
        }}
      >
        漏水みはり番
      </div> */}
      <LTETable />
    </>
  );
};

const SelectedSection = (props: any) => {
  // if (props.section === SECTION.PICO3) {
  //   return <Pico3Section />;
  // }
  // if (props.section === SECTION.LTE) {
  return <LTESection />;
  // }
  // return (
  //   <>
  //     <Pico3Section />
  //     <LTESection />
  //   </>
  // );
};

const DevicesContents = ({ reload }: { reload: () => void }) => {
  const a = useContext(AppContext).account;
  const d = useContext(AppContext).dataUser.locations;
  const c = useContext(AppContext).dataUser.camera;
  const p = d.pageDevices;
  // const [section, setSection] = useState(SECTION.ALL);

  // const handleChangeSection = (e: any) => {
  //   setSection(e.target.value);
  // };

  const handleRegisterDlgOpen = () => {
    p.bShowRegisterDlg = true;
    c.GetCameras()
      .then(() => {
        p.changed();
      })
      .catch((err: any) => {
        console.log("カメラ情報取得失敗");
        console.error(err);
      });
    p.changed();
  };

  return (
    <>
      {a.IsUserViewer() ? (
        <div style={{ marginTop: "16px" }} /> // スペーサー
      ) : (
        <ButtonDlg
          variant="contained"
          color="primary"
          onClick={handleRegisterDlgOpen}
          startIcon={<AddCircle />}
        >
          デバイスの追加
        </ButtonDlg>
      )}
      {/* <Select
        labelId="select_sensor_label"
        id="select_Section"
        onChange={(e) => handleChangeSection(e)}
        defaultValue={SECTION.ALL}
        style={{ minWidth: "10%", left: "2%", height: "40px" }}
      >
        <MenuItem value={SECTION.PICO3} key={SECTION.PICO3}>
          <div style={{ width: "200px" }}>Pico3</div>
        </MenuItem>
        <MenuItem value={SECTION.LTE} key={SECTION.LTE}>
          <div style={{ width: "200px" }}>漏水みはり番</div>
        </MenuItem>
        <MenuItem value={SECTION.ALL} key={SECTION.ALL}>
          <div style={{ width: "200px" }}>Pico3+漏水みはり番</div>
        </MenuItem>
      </Select> */}
      <CurrentSection.Provider value={SECTION.LTE}>
        <SelectedSection section={SECTION.LTE} />
      </CurrentSection.Provider>
      <RegisterForm />
      {/* <DetailFormPico3 reload={reload} /> */}
      <DetailFormLTE reload={reload} />
    </>
  );
};

const DevicesPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const d = useContext(AppContext).dataUser.locations;
  const p = d.pageDevices;
  useModel(p);

  const reload = () => {
    const items = searchParams.getAll("building");
    if (items.length === 0) {
      navigate("/buildings/");
    }
    d.GetLocationAndDeviceData()
      .then(() => {
        const index = d.SearchLocation(items[0]);
        if (index < 0) {
          navigate("/buildings/");
        } else {
          p.building = d.locations[index];
          p.pico3 = d.GetPico3List(p.building.BuildingId);
          p.LTE = d.GetLTEList(p.building.BuildingId);
          p.changed();
        }
      })
      .catch((err: any) => {
        d.SetError(err, "データ取得失敗");
        navigate("/buildings/");
      });
  };

  useEffect(() => {
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageTemplate title={p.building.BuildingName}>
      <BreadCrumbList
        items={[
          new BreadCrumbItem("TOP", "/top/"),
          new BreadCrumbItem("建物一覧", "/buildings/"),
          new BreadCrumbItem(p.building.BuildingName),
        ]}
      />
      <DevicesContents reload={reload} />
    </PageTemplate>
  );
};

export default DevicesPage;
